import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { SignupEmbedderOptions } from 'signup-embedder';
import { BackLink } from '../views-components/BackLink';
import { ProgressIndicator } from '../views-components/ProgressIndicator';
import { Header } from './AppHeader';
export const FramedAppHeader = () => {
  const showProgressIndicator = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_SHOW_PROGRESS_INDICATOR_OPTION);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showProgressIndicator && /*#__PURE__*/_jsx(ProgressIndicator, {}), /*#__PURE__*/_jsx(Header, {
      className: "Header",
      children: /*#__PURE__*/_jsx(BackLink, {})
    })]
  });
};